module.exports = __webpack_public_path__ + "img/company.ad2e48ed.png";